import React, { useEffect } from "react";

import Web3CommonHeader from "@/components/Web3/Common/Header";
import { useStoredDataDispatch } from "@/store";
import { SupTransactionType } from "@/types";

import { SupLock } from "@repo/core-ui";
import { SupText } from "@repo/core-ui";

interface Web3CommonCartDisabledProps {
  type?: SupTransactionType;
}

export default function Web3CommonCartDisabled({ type = "deposit" }: Web3CommonCartDisabledProps) {
  const storedDispatch = useStoredDataDispatch();
  useEffect(() => {
    storedDispatch({ type: type === "deposit" ? "clearCart" : "clearWithdrawCart" });
  });

  return (
    <div className="flex h-full max-h-screen w-full flex-grow flex-col items-stretch p-[24px] pt-0 lg:justify-between ">
      <Web3CommonHeader type={type} />
      <div className="flex h-full flex-col items-center justify-center space-y-4 text-warning-600">
        <SupLock className="h-10 w-10" />
        <SupText variant="subtitle1" color="warning">
          All {type === "withdraw" ? "withdrawals" : "deposits"} were temporarily disabled
        </SupText>
      </div>
    </div>
  );
}
